module.exports = __webpack_public_path__ + "media/packs/landing_page/images/logo-7fe3f66837f6a8f6ba1ffa01d63839ed.png";